import Vue from 'vue'
import Router from 'vue-router'
import App from './App.vue'

import '@/assets/css/definitions.css'
import '@/assets/css/baseElements.css'
import '@/assets/css/prodSpecific.css'
import '@/assets/css/globalClasses.css'
import '@/assets/font/HappsNewsGothic.css'
import '@/assets/font/HappsNewsGothicCondensed.css'


Vue.config.productionTip = false

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'faq',
    },
    {
      // if path not found, redirect to home
      path: '*',
      redirect: { name: 'faq' },
    },
  ],
})

new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
